exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "retailer-groups-existing-user-field {\n  display: block; }\n  retailer-groups-existing-user-field input {\n    width: auto;\n    flex: 1 1 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/modules/retailer-groups/components/existing-user-field/retailer-groups-existing-user-field.scss
// module id = 1791
// module chunks = 0